import { Space, Typography, theme } from "../ui";
import { spacing, typography } from "../layout/spacing";
import type { FeatureTeaserData } from "./featureLockTypes";

const { Text } = Typography;

export function FeatureTariffInformation({ feature, translate }: {
  feature: FeatureTeaserData;
  translate: (key: string, fallbackDe: string) => string;
}) {
  const { token } = theme.useToken();
  return (
    <Space direction="vertical" size={spacing.microGap} style={{ width: "100%" }}>
      {feature.planName && (
        <Text type="secondary" style={{ fontSize: typography.base }}>
          {translate("Included in plan:", "Enthalten im Tarif:")}{" "}
          <Text strong style={{ color: token.colorText }}>{feature.planName}</Text>
          {feature.planPriceText ? ` (${feature.planPriceText})` : ""}
        </Text>
      )}
      {feature.addonName && (
        <Text type="secondary" style={{ fontSize: typography.base }}>
          {translate("Optionally available as add-on:", "Alternativ als Zusatzoption zubuchbar:")}{" "}
          <Text strong style={{ color: token.colorText }}>{feature.addonName}</Text>
          {feature.addonPriceText ? ` (${feature.addonPriceText})` : ""}
        </Text>
      )}
      <Text type="secondary" style={{ display: "block", marginTop: spacing.microGap, fontSize: typography.base }}>
        {feature.tariffNotice ?? translate(
          "You can change your plan or add this option in billing settings.",
          "In der Tarifverwaltung unter Abrechnung können Sie Ihren Tarif wechseln oder einzelne Optionen direkt zubuchen."
        )}
      </Text>
    </Space>
  );
}
